import { Fieldset, Stack, Title } from '@mantine/core';
import { AssetSimplificationMode } from './settings/AssetSimplificationMode';
import { PolygonDistributionMethod } from './settings/PolygonDistributionMethod';
import { VertexMergingDistance } from './settings/VertexMergingDistance';
import { BoundaryPreservation } from './settings/BoundaryPreservation';
import { PreserveTopology } from './settings/PreserveTopology';
import { MaterialAndTextureBaking } from './settings/MaterialAndTextureBaking';
import { UvAndAtlas } from './settings/UvAndAtlas';

export function AssetsSimplificationOperation() {
  return (
    <Stack align='flex-start' mb='lg'>
      <Title order={5}>Asset simplification</Title>
      <Fieldset disabled={false} variant='unstyled'>
        <Stack gap='xl'>
          <AssetSimplificationMode />
          <PolygonDistributionMethod />
          <VertexMergingDistance />
          <BoundaryPreservation />
          <PreserveTopology />
          <MaterialAndTextureBaking />
          <UvAndAtlas />
        </Stack>
      </Fieldset>
    </Stack>
  );
}
